import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import ResearchPane from 'components/resources/ResearchPane.vue';
import AnalysisPane from 'components/resources/AnalysisPane.vue';
import { ref } from 'vue';
import EditsPane from 'components/resources/edits/EditsPane.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'ResourcesPane',
  setup(__props) {

const tab = ref('research');

return (_ctx: any,_cache: any) => {
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_tabs, {
      modelValue: tab.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
      dense: "",
      "no-caps": "",
      outlined: "",
      class: "text-grey",
      "active-color": "primary",
      "indicator-color": "primary",
      align: "justify"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_tab, {
          name: "research",
          icon: "fa-solid fa-book",
          label: "Research"
        }),
        _createVNode(_component_q_tab, {
          name: "analysis",
          icon: "fa-solid fa-binoculars",
          label: "MS DRG Analysis"
        }),
        _createVNode(_component_q_tab, {
          name: "edits",
          icon: "fa-regular fa-flag",
          label: "Edits"
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_separator),
    _createVNode(_component_q_tab_panels, {
      class: "full-height",
      modelValue: tab.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tab).value = $event)),
      animated: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_tab_panel, { name: "research" }, {
          default: _withCtx(() => [
            _createVNode(ResearchPane)
          ]),
          _: 1
        }),
        _createVNode(_component_q_tab_panel, { name: "analysis" }, {
          default: _withCtx(() => [
            _createVNode(AnalysisPane)
          ]),
          _: 1
        }),
        _createVNode(_component_q_tab_panel, { name: "edits" }, {
          default: _withCtx(() => [
            _createVNode(EditsPane)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})